"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
const hash = '__light__extend__';
exports.LightExtend = (...config) => (target, property) => {
    const key = getMetadataKey(property);
    Reflect.defineMetadata(key, config, target);
};
function getMetadataKey(property) {
    return `${hash}:${property}`;
}
exports.getMetadataKey = getMetadataKey;
function getMetadataValue(property, target) {
    return Reflect.getMetadata(getMetadataKey(property), target);
}
exports.getMetadataValue = getMetadataValue;
function hasMetadata(property, target) {
    return Reflect.hasMetadata(getMetadataKey(property), target);
}
exports.hasMetadata = hasMetadata;
//# sourceMappingURL=light-extend.decorator.js.map